import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './MainPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* 根路径直接渲染 MainPage (默认英文) */}
        <Route path="/" element={<MainPage />} />
        
        {/* Static Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />

        {/* 语言路径 */}
        <Route path="/:lang" element={<MainPage />} />
        
        {/* 捕获所有其他路径并重定向回根目录 */}
        <Route path="*" element={<MainPage />} />
      </Routes>
    </Router>
  );
};

export default App;
